<template>
  <div>
    <div class="main-content">
      <!-- Filters -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div
                class="card-title"
                data-toggle="collapse"
                data-target="#collapseFilter"
                role="button"
                aria-expanded="false"
                aria-controls="collapseFilter"
                style="cursor: pointer;"
              >
                Filtros
                <button
                  class="btn btn-inform"
                  data-toggle="collapse"
                  data-target="#collapseFilter"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseFilter"
                >
                  <i class="fas fa-angle-down"></i>
                </button>
              </div>
            </div>

            <div class="collapse" id="collapseFilter">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="filterDateIn">Data Início</label>
                      <datetime
                        v-model="filter.dateStart"
                        class="form-control along"
                        :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                        value-zone="America/Sao_Paulo"
                        zone="America/Sao_Paulo"
                      ></datetime>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="filterDateEnd">Data Fim</label>
                      <datetime
                        v-model="filter.dateEnd"
                        class="form-control along"
                        :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                        value-zone="America/Sao_Paulo"
                        zone="America/Sao_Paulo"
                      ></datetime>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="filterCompany">Empresa</label>
                      <v-select
                        v-model="filter.company_id"
                        :options="companies"
                        :reduce="companies => companies.id"
                        label="fantasy_name"
                        class="style-chooser"
                        id="companies"
                        multiple
                      >
                        <div slot="no-options">Nenhum registro encontrado.</div>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="filterBranch">Unidade</label>
                      <v-select
                        v-model="filter.branch_id"
                        :options="filteredBranches"
                        :reduce="filteredBranches => filteredBranches.id"
                        label="name"
                        class="style-chooser"
                        id="branches"
                        multiple
                      >
                        <div slot="no-options">Nenhum registro encontrado.</div>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="filterSection">Departamento</label>
                      <v-select
                        v-model="filter.sector_id"
                        :options="filteredSectors"
                        :reduce="filteredSectors => filteredSectors.id"
                        label="name"
                        class="style-chooser"
                        id="sectors"
                        multiple
                      >
                        <div slot="no-options">Nenhum registro encontrado.</div>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="filterPosition">Cargo</label>
                      <v-select
                        v-model="filter.role_id"
                        :options="filteredRoles"
                        :reduce="filteredRoles => filteredRoles.id"
                        label="name"
                        class="style-chooser"
                        id="roles"
                        multiple
                      >
                        <div slot="no-options">Nenhum registro encontrado.</div>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="filterDocumentStatus">Status do Documento</label>
                      <v-select
                        v-model="filter.document_status"
                        :options="document_status"
                        :reduce="document_status => document_status.id"
                        label="name"
                        class="style-chooser"
                        id="document_status"
                        multiple
                      >
                        <div slot="no-options">Nenhum registro encontrado.</div>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="filterDocumentType">Tipo do Documento</label>
                      <v-select
                        v-model="filter.document_type"
                        :options="document_types"
                        :reduce="document_types => document_types.id"
                        label="name"
                        class="style-chooser"
                        id="document_types"
                        multiple
                      >
                        <div slot="no-options">Nenhum registro encontrado.</div>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="filterDocumentName">Nome do Documento</label>
                      <v-select
                        v-model="filter.docto"
                        :options="documents"
                        :reduce="documents => documents.id"
                        label="name"
                        class="style-chooser"
                        id="documents"
                        multiple
                      >
                        <div slot="no-options">Nenhum registro encontrado.</div>
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-4 mt-3">
                    <button class="btn btn-next btn-block" @click="getDashboards()">
                      Filtrar
                      <i class="fas fa-filter"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-content">
      <!-- Highlights -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Indicadores</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="card-subtitle mb-3">Quantidade Total de Documentos</div>
                  <div id="app">
                    <HorizontalBar
                      v-if="loaded"
                      class="aspectCharts"
                      :chart-data="totalDocuments"
                      :options="options"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card-subtitle mb-3">Porcentagem de Assinaturas</div>
                  <div id="app">
                    <donut
                      v-if="loaded"
                      class="aspectCharts"
                      :chart-data="percentageSignatures"
                      :options="percentageSignatures.options"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card-subtitle mb-3">Tempo Médio para Assinatura</div>
                  <div id="app">
                    <Bar
                      v-if="loaded"
                      class="aspectCharts"
                      :chart-data="subscriptionTime"
                      :options="options"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card-subtitle mb-3">Assinaturas Mensais</div>
                  <div id="app">
                    <LineChart
                      v-if="loaded"
                      class="aspectCharts"
                      :chart-data="monthlySubscriptions"
                      :options="options"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card-subtitle mb-3">Assinaturas por Empresa</div>
                  <div id="app">
                    <Bar
                      v-if="loaded"
                      class="aspectCharts"
                      :chart-data="subscriptionCompany"
                      :options="options"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card-subtitle mb-3">Assinaturas por Unidade</div>
                  <div id="app">
                    <Bar
                      v-if="loaded"
                      class="aspectCharts"
                      :chart-data="subscriptionBranch"
                      :options="options"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card-subtitle mb-3">Assinaturas por Departamento</div>
                  <div id="app">
                    <Bar
                      v-if="loaded"
                      class="aspectCharts"
                      :chart-data="subscriptionDepartment"
                      :options="options"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card-subtitle mb-3">Assinaturas por Cargo</div>
                  <div id="app">
                    <Bar
                      v-if="loaded"
                      class="aspectCharts"
                      :chart-data="subscriptionRole"
                      :options="options"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/Charts/Line.js";
import Donut from "@/components/Charts/Donut.js";
import HorizontalBar from "@/components/Charts/HorizontalBar.js";
import Bar from "@/components/Charts/Bar.js";

export default {
  data() {
    return {
      filter: {
        company_id: [],
        dateStart: "",
        dateEnd: ""
      },
      companies: [],
      branches: [],
      sectors: [],
      roles: [],
      document_status: [],
      documents: [],
      document_types: [
        { id: 1, name: "Contrato" },
        { id: 2, name: "Notificação" },
        { id: 3, name: "Vistoria" }
      ],
      loaded: false,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        height: 200
      },
      monthlySubscriptions: "",
      monthlySubscriptions: {
        datasets: [
          {
            label: "Qtde. de Assinaturas",
            backgroundColor: "transparent",
            borderColor: "#fab1a0",
            borderWidth: 2,
            radius: 5
          }
        ]
      },
      percentageSignatures: {
        labels: ["% Assinados", "% Pendentes"],
        datasets: [
          {
            borderWidth: "2",
            borderColor: [
              this.convertHex("#55efc4", 100),
              this.convertHex("#cccccc", 100)
            ],
            backgroundColor: [
              this.convertHex("#55efc4", 5),
              this.convertHex("#cccccc", 5)
            ]
          }
        ],
        options: {
          responsive: true,
          tooltips: {
            mode: "index",
            intersect: false
          },
          hover: {
            mode: "nearest",
            intersect: true
          },
          legend: {
            position: "top"
          },
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          responsive: true,
          maintainAspectRatio: false,
          height: 100
        }
      },
      totalDocuments: {
        type: "horizontalBar",
        labels: ["Assinatura"],
        datasets: [
          {
            label: "Assinado",
            borderWidth: "2",
            borderColor: [this.convertHex("#55efc4", 100)],
            backgroundColor: [this.convertHex("#55efc4", 5)],
            data: "300"
          },
          {
            label: "Pendente",
            borderWidth: "2",
            borderColor: [this.convertHex("#ffeaa7", 100)],
            backgroundColor: [this.convertHex("#ffeaa7", 5)]
          },
          {
            label: "Atrasado",
            borderWidth: "2",
            borderColor: [this.convertHex("#74b9ff", 100)],
            backgroundColor: [this.convertHex("#74b9ff", 5)]
          },
          {
            label: "Cancelado",
            borderWidth: "2",
            borderColor: [this.convertHex("#ff7675", 100)],
            backgroundColor: [this.convertHex("#ff7675", 5)]
          }
        ]
      },
      subscriptionTime: {
        labels: [
          "1 dia",
          "2 dias",
          "3 dias",
          "4 dias",
          "5 dias",
          "6 dias",
          "7 dias ou +"
        ],
        datasets: [
          {
            label: "Qtde. de Dias",
            borderColor: this.convertHex("#a29bfe", 100),
            borderWidth: "2",
            backgroundColor: this.convertHex("#a29bfe", 5),
            data: ["206", "587", "1086", "463", "227", "348", "145"]
          }
        ]
      },
      subscriptionCompany: {
        labels: ["Estapar", "Innovare TI"],
        datasets: [
          {
            label: "Qtde. de Assinaturas",
            borderColor: this.convertHex("#74b9ff", 100),
            borderWidth: "2",
            backgroundColor: this.convertHex("#74b9ff", 5),
            data: ["2581", "159"]
          }
        ]
      },
      subscriptionBranch: {
        labels: ["São Paulo", "Campinas", "Jundiaí"],
        datasets: [
          {
            label: "Qtde. de Assinaturas",
            borderColor: this.convertHex("#fab1a0", 100),
            borderWidth: "2",
            backgroundColor: this.convertHex("#fab1a0", 5),
            data: ["1679", "684", "258"]
          }
        ]
      },
      subscriptionDepartment: {
        labels: ["São Paulo", "Campinas", "Jundiaí"],
        datasets: [
          {
            label: "Qtde. de Assinaturas",
            borderColor: this.convertHex("#a29bfe", 100),
            borderWidth: "2",
            backgroundColor: this.convertHex("#a29bfe", 5),
            data: ["1679", "684", "258"]
          }
        ]
      },
      subscriptionRole: {
        labels: ["São Paulo", "Campinas", "Jundiaí"],
        datasets: [
          {
            label: "Qtde. de Assinaturas",
            borderColor: this.convertHex("#55efc4", 100),
            borderWidth: "2",
            backgroundColor: this.convertHex("#55efc4", 5),
            data: ["1679", "684", "258"]
          }
        ]
      }
    };
  },
  computed: {
    filteredBranches: function() {
      var bcs = [];
      for (var i = 0; i <= this.filter.company_id.length; i++) {
        var b2 = this.branches.filter(
          x => x.company_id == this.filter.company_id[i]
        );
        bcs.push(b2[0]);
      }
      bcs.splice(i - 1);
      return bcs;
    },
    filteredSectors: function() {
      var scs = [];
      for (var i = 0; i <= this.filter.company_id.length; i++) {
        var c2 = this.sectors.filter(
          x => x.company_id == this.filter.company_id[i]
        );
        scs.push(c2[0]);
      }
      scs.splice(i - 1);
      return scs;
    },
    filteredRoles: function() {
      var rls = [];
      for (var i = 0; i <= this.filter.company_id.length; i++) {
        var c2 = this.roles.filter(
          x => x.company_id == this.filter.company_id[i]
        );
        rls.push(c2[0]);
      }
      rls.splice(i - 1);
      return rls;
    }
  },
  methods: {
    convertHex(hex, opacity) {
      hex = hex.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      const result =
        "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
      return result;
    },
    getCompanies: function() {
      const self = this;
      const api =
        self.$store.state.api + "companies?paginated=false&with[]=branches";
      self.$http
        .get(api)
        .then(response => {
          self.companies = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBranches: function() {
      const self = this;
      const api = self.$store.state.api + "branches?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          self.branches = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getSectors: function() {
      const self = this;
      const api = self.$store.state.api + "sectors?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          self.sectors = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getRoles: function() {
      const self = this;
      const api = self.$store.state.api + "roles?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          self.roles = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getDocumentStatus: function() {
      const self = this;
      const api = self.$store.state.api + "documentstatuses?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          self.document_status = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getDocuments: function() {
      const self = this;
      const api = self.$store.state.api + "signaturedocuments?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          self.documents = response.data.data;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getDashboards: function() {
      const self = this;
      self.loaded = false;
      const api = self.$store.state.api + "signaturehome?paginated=false";
      self.$http
        .post(api, {
          filters: self.filter
        })
        .then(response => {
          self.home = response.data.data;
          self.percentageSignatures.datasets[0].data =
            response.data.percent_signeds;

          self.totalDocuments.datasets[0].data = response.data.signed;
          self.totalDocuments.datasets[1].data = response.data.pending;
          self.totalDocuments.datasets[2].data = response.data.late;
          self.totalDocuments.datasets[3].data = response.data.canceled;

          self.subscriptionCompany.labels = response.data.labels_companies;
          self.subscriptionCompany.datasets[0].data =
            response.data.values_companies;

          self.subscriptionBranch.labels = response.data.labels_branches;
          self.subscriptionBranch.datasets[0].data =
            response.data.values_branches;

          self.subscriptionDepartment.labels = response.data.labels_sectors;
          self.subscriptionDepartment.datasets[0].data =
            response.data.values_sectors;

          self.subscriptionRole.labels = response.data.labels_roles;
          self.subscriptionRole.datasets[0].data = response.data.values_roles;

          self.subscriptionTime.datasets[0].data =
            response.data.values_subst_times;

          self.monthlySubscriptions.labels = response.data.labels_subst_months;
          self.monthlySubscriptions.datasets[0].data =
            response.data.values_subst_months;

          this.loaded = true;
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    }
  },
  mounted() {
    this.getDashboards();
    this.getCompanies();
    this.getBranches();
    this.getSectors();
    this.getRoles();
    this.getDocumentStatus();
    this.getDocuments();
  },
  components: {
    LineChart,
    Donut,
    HorizontalBar,
    Bar
  }
};
</script>
<style>
.date-time-picker .field-input[data-v-74507c40] {
  border: none;
  padding: 4px;
  border-bottom: 2px solid #03a830;
  color: #03a830;
}
.aspectCharts {
  height: 250px;
  margin: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue